import { render, staticRenderFns } from "./SendContent.vue?vue&type=template&id=7e152249&scoped=true&"
import script from "./SendContent.vue?vue&type=script&lang=js&"
export * from "./SendContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e152249",
  null
  
)

export default component.exports